import { render, staticRenderFns } from "./EaVgasGameTileGiveawayList.vue?vue&type=template&id=d80b8640&lang=pug&"
import script from "./EaVgasGameTileGiveawayList.vue?vue&type=script&lang=js&"
export * from "./EaVgasGameTileGiveawayList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports